export default __webpack_public_path__ + "static/media/you-can.8ad61522.svg";